import VueBase from '@/pages/vue-base'

export default abstract class FormBase extends VueBase {
  valid = true
  validated = false

  validate(): boolean {
    return false
  }
}
